export default {"src":"/_next/static/media/topic.e463f101.svg","height":608,"width":560,"blurWidth":0,"blurHeight":0};